import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '../store/auth-store.js';
import { isNativePlatform } from '../lib/platform.js';
import { initPushNotifications, setPushNavigator } from '../lib/push-notifications.js';

/**
 * Native push wiring (M4.3). Mounted inside the authenticated shell so it only
 * runs once the user is signed in:
 *   - hands React Router's `navigate` to the push module (tap → deep-link),
 *   - requests permission + registers the FCM token once authenticated.
 * No-ops entirely on web.
 */
export function useNativePush(): void {
  const navigate = useNavigate();
  const status = useAuthStore((s) => s.status);

  useEffect(() => {
    if (!isNativePlatform()) return;
    setPushNavigator((route) => navigate(route));
    if (status === 'authenticated') {
      void initPushNotifications();
    }
  }, [navigate, status]);
}
